/* eslint-disable */
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  Input,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select as MuiSelect,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Typography
} from "@material-ui/core";
import NoSsr from "@material-ui/core/NoSsr";
import {
  createTheme,
  MuiThemeProvider,
  withStyles
} from "@material-ui/core/styles";
import { emphasize } from "@material-ui/core/styles/colorManipulator";
import Edit from "@material-ui/icons/Edit";
import classnames from "classnames";
import React, { Component, Fragment } from "react";
import { Redirect } from "react-router";
import Select from "react-select";
import { rawsuggestions } from "./Branchlist";
import countryList from "./countryList";
import { CalculatorProvider } from "./Deposits/CalculatorProvider";
import RenderCalculator from "./Deposits/RenderCalculator";
import {
  HomeTelCustom,
  MobileCustom,
  TinCustom,
  setDateBackEnd,
  maxDate18
} from "./Forms/CommonComponents";
import ModalButtons from "./ModalButtons";
import { PrivacyStatementText } from "./PrivacyStatement";
import { TermsOfUseText } from "./TermsOfUse";

const theme = createTheme({
  palette: {
    primary: {
      main: "#6a1b9a"
    }
  }
});

const styles = theme => ({
  header: {
    alignItems: "center",
    padding: theme.spacing(2),
    marginBottom: 20
  },
  headline: {
    margin: theme.spacing(3),
    color: theme.palette.secondary.main
  },
  bold: {
    fontWeight: "500"
  },
  textField: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  root: {
    paddingTop: theme.spacing(2)
  },
  gradient: {
    paddingTop: theme.spacing(2),
    background:
      "linear-gradient(to bottom, rgba(242,242,242,0.98) 0%,rgba(210,210,210,0.82) 67%,rgba(184,184,184,0.89) 85%,rgba(174,174,174,1) 100%)",
    "& > div": {
      padding: "0 10px 25px"
    }
  },
  formControl: {
    width: "100%",
    marginTop: theme.spacing(1)
  },
  dateOfBirth: {
    width: "100%"
  },
  setMarginZero: {
    marginTop: 0,
    minHeight: 0,
    "&$error": {
      marginTop: "30px!important"
    }
  },
  dropdownError: {
    marginTop: "0",
    minHeight: "0",
    "&$error": {
      marginTop: "8px",
      minHeight: "1rem"
    }
  },
  error: {},
  input: {
    display: "flex",
    padding: 0,
    marginTop: theme.spacing(1)
  },
  valueContainer: {
    display: "flex",
    flex: 1,
    alignItems: "center"
  },
  chip: {
    margin: `${theme.spacing(1 / 2)}px ${theme.spacing(1 / 4)}px`
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === "light"
        ? theme.palette.grey[300]
        : theme.palette.grey[700],
      0.08
    )
  },
  noOptionsMessage: {
    fontSize: 16,
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
  },
  singleValue: {
    fontSize: 16
  },
  placeholder: {
    position: "absolute",
    left: 0,
    fontSize: 16
  },
  autoCompleteStyle: {
    "& > div > div:before": {
      borderBottom: "1.5px solid #f44336"
    }
  },
  groupControl: {
    display: "block",
    margin: "-1.5rem 0 -1rem "
  },
  group: {
    margin: `${theme.spacing(1)}px 0`,
    flexDirection: "row",
    display: "inline-flex",
    left: 20,
    top: 6,
    position: "relative"
  },
  table: {
    "& h3": {
      display: "flex",
      justifyContent: "space-between"
    }
  },
  saveButton: {
    "& span button span": {
      color: "#fff!important"
    }
  },
  actionsContainer: {
    paddingTop: "16px"
  }
});

const countrySuggestions = countryList.map(suggestion => ({
  value: suggestion.countrycode,
  label: suggestion.country
}));

const suggestions = rawsuggestions.map(rawsuggestion => ({
  value: rawsuggestion.branchcode,
  label: rawsuggestion.label
}));

const customAutoSuggestStyles = {
  option: (base, state) => ({
    ...base,
    borderBottom: "1px dotted pink",
    color: state.isFullscreen ? "red" : "blue",
    padding: 20
  }),
  input: () => ({
    // none of react-selects styles are passed to <View />
    height: 10
  }),
  singleValue: (base, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";

    return { ...base, opacity, transition };
  }
};

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          ref: props.innerRef,
          children: props.children,
          ...props.innerProps
        }
      }}
    />
  );
}

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography
      className={props.selectProps.classes.singleValue}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function ValueContainer(props) {
  return (
    <div className={props.selectProps.classes.valueContainer}>
      {props.children}
    </div>
  );
}


const components = {
  Option,
  Control,
  NoOptionsMessage,
  Placeholder,
  SingleValue,
  ValueContainer
};

class SaveButton extends React.Component {
  state = {
    open: false
  };

  handleClickOpen = () => {
    this.setState({ open: true });
    this.props.onClick();
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { buttonTitle, header, dialogBody } = this.props;
    return (
      <React.Fragment>
        <Button
          variant="contained"
          color="secondary"
          onClick={this.handleClickOpen}
        >
          {buttonTitle}
        </Button>
        <Dialog
          name={this.state.selectedValue}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title" color="secondary">
            {header}
          </DialogTitle>
          <DialogContent>
            <Typography align="center" component="p">
              {dialogBody}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="secondary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

const FormContext = React.createContext();

class GetStarted extends Component {
  render() {

    const { classes } = this.props;
    return (
      <Fragment>
        <FormContext.Consumer>
          {context => (
            <form>
              <MuiThemeProvider theme={theme}>
                <TextField
                  required
                  autoComplete="email"
                  type="email"
                  id="email"
                  name="email"
                  label="Enter Your Email Address"
                  className={classes.textField}
                  value={context.state.email}
                  onChange={context.change}
                  error={context.state.emailError !== ""}
                  helperText={context.state.emailError}
                  margin="normal"
                />
                <TextField
                  id="date"
                  label="Birthday"
                  type="date"
                  name="dateOfBirth"
                  className={classes.textField}
                  value={context.state.dateOfBirth}
                  onChange={context.change}
                  error={context.state.dateOfBirthError !== ""}
                  helperText={context.state.dateOfBirthError}
                  inputProps={{
                    min: "1910-07-31",
                    max: maxDate18
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                />

                <FormControl
                  className={classes.formControl}
                  error={context.state.preferredStoreError !== false}
                >
                  <NoSsr>
                    <Select
                      styles={customAutoSuggestStyles}
                      className={
                        context.state.preferredStoreError !== false
                          ? classes.autoCompleteStyle
                          : ""
                      }
                      classes={classes}
                      options={suggestions}
                      components={components}
                      value={context.state.branchCode}
                      onChange={context.handleSelectChange("branchCode")}
                      placeholder={
                        context.state.preferredStoreError !== false ? (
                          <span style={{ color: "#f44336" }}>
                            Please Select Preferred Store.
                          </span>
                        ) : (
                          "Please Select Preferred Store."
                        )
                      }
                    />
                  </NoSsr>
                  <Typography component="p">
                    {context.state.branchAddr}
                  </Typography>
                  <FormHelperText
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error
                    }}
                    component="span"
                  >
                    {context.state.preferredStoreError}
                  </FormHelperText>
                </FormControl>
              </MuiThemeProvider>
              <RenderCalculator />
              <br />
            </form>
          )}
        </FormContext.Consumer>
      </Fragment>
    );
  }
}

const GetStarted1 = withStyles(styles, { withTheme: true })(GetStarted);

class PersonalInformation extends Component {
  render() {
    const { classes } = this.props;
    return (
      <FormContext.Consumer>
        {context => (
          <form>
            <MuiThemeProvider theme={theme}>
              <TextField
                required
                type="text"
                autoComplete="given-name"
                color="primary"
                id="firstName"
                name="firstName"
                label="First Name"
                className={classes.textField}
                value={context.state.firstName}
                onChange={context.change}
                error={context.state.firstNameError !== ""}
                helperText={context.state.firstNameError}
                margin="normal"
              />
              <TextField
                required
                type="text"
                autoComplete="additional-name"
                color="primary"
                id="middleName"
                name="middleName"
                label="Middle Name"
                className={classes.textField}
                value={context.state.middleName}
                onChange={context.change}
                error={context.state.middleNameError !== ""}
                helperText={context.state.middleNameError}
                margin="normal"
              />
              <TextField
                required
                type="text"
                autoComplete="family-name"
                color="primary"
                id="lastName"
                name="lastName"
                label="Last Name"
                className={classes.textField}
                value={context.state.lastName}
                onChange={context.change}
                error={context.state.lastNameError !== ""}
                helperText={context.state.lastNameError}
                margin="normal"
              />
              <FormControl
                className={classes.formControl}
                error={context.state.birthCountryError !== ""}
              >
                <NoSsr>
                  <Select
                    styles={{ border: "1px solid black" }}
                    className={
                      context.state.birthCountryError !== ""
                        ? classes.autoCompleteStyle
                        : ""
                    }
                    classes={classes}
                    options={countrySuggestions}
                    components={components}
                    value={context.state.birthCountry}
                    onChange={context.handleCountryChange("birthCountry")}
                    placeholder={
                      context.state.birthCountryError !== "" ? (
                        <span style={{ color: "#f44336" }}>
                          Select Country Of Birth
                        </span>
                      ) : (
                        "Select Country Of Birth"
                      )
                    }
                  />
                </NoSsr>
                <FormHelperText
                  classes={{
                    root: classes.dropdownError,
                    error: classes.error
                  }}
                  component="span"
                >
                  {context.state.birthCountryError}
                </FormHelperText>
              </FormControl>
              <TextField
                required
                type="text"
                color="secondary"
                id="placeOfBirth"
                name="placeOfBirth"
                label="Place Of Birth"
                className={classes.textField}
                value={context.state.placeOfBirth}
                onChange={context.change}
                error={context.state.placeOfBirthError !== ""}
                helperText={context.state.placeOfBirthError}
                margin="normal"
              />
              <FormControl
                className={classes.formControl}
                error={context.state.genderError !== ""}
              >
                <InputLabel htmlFor="gender">Gender</InputLabel>
                <MuiSelect
                  native
                  className={classes.textField}
                  value={context.state.gender}
                  onChange={context.change}
                  name="gender"
                >
                  <option value="" />
                  <option value="MALE">Male</option>
                  <option value="FEMALE">Female</option>
                </MuiSelect>
                <FormHelperText
                  classes={{
                    root: classes.dropdownError,
                    error: classes.error
                  }}
                  component="span"
                >
                  {context.state.genderError}
                </FormHelperText>
              </FormControl>
              <FormControl
                className={classes.formControl}
                error={context.state.nationalityError !== ""}
              >
                <NoSsr>
                  <Select
                    styles={{ border: "1px solid black" }}
                    className={
                      context.state.nationalityError !== ""
                        ? classes.autoCompleteStyle
                        : ""
                    }
                    classes={classes}
                    options={countrySuggestions}
                    components={components}
                    value={context.state.nationality}
                    onChange={context.handleCountryChange("nationality")}
                    placeholder={
                      context.state.nationalityError !== "" ? (
                        <span style={{ color: "#f44336" }}>
                          Select Nationality
                        </span>
                      ) : (
                        "Select Nationality"
                      )
                    }
                  />
                </NoSsr>
                <FormHelperText
                  classes={{
                    root: classes.dropdownError,
                    error: classes.error
                  }}
                  component="span"
                >
                  {context.state.nationalityError}
                </FormHelperText>
              </FormControl>
              <FormControl
                className={classes.formControl}
                error={context.state.civilStatusError !== ""}
              >
                <InputLabel htmlFor="civilStatus">Civil Status</InputLabel>
                <MuiSelect
                  native
                  value={context.state.civilStatus}
                  className={classes.textField}
                  onChange={context.change}
                  name="civilStatus"
                >
                  <option value="" />
                  <option value="DIVORCED">Divorced</option>
                  <option value="MARRIED">Married</option>
                  <option value="SEPARATE">Separated</option>
                  <option value="SINGLE">Single</option>
                  <option value="WIDOWED">Widowed</option>
                </MuiSelect>
                <FormHelperText
                  classes={{
                    root: classes.dropdownError,
                    error: classes.error
                  }}
                  component="span"
                >
                  {context.state.civilStatusError}
                </FormHelperText>
              </FormControl>
              <FormControl
                className={classes.formControl}
                error={context.state.tinError !== ""}
              >
                <InputLabel htmlFor="formatted-text-mask-input">
                  Tin *
                </InputLabel>
                <Input
                  value={context.state.tin}
                  onChange={context.handleNumberChange("tin")}
                  id="formatted-text-mask-input"
                  inputComponent={TinCustom}
                />
                <FormHelperText
                  classes={{
                    root: classes.dropdownError,
                    error: classes.error
                  }}
                  component="span"
                >
                  {context.state.tinError}
                </FormHelperText>
              </FormControl>
              <FormControl
                className={classes.formControl}
                error={context.state.employmentStatusError !== ""}
              >
                <InputLabel htmlFor="employmentStatus">
                  Employment Status
                </InputLabel>
                <MuiSelect
                  native
                  value={context.state.employmentStatus}
                  onChange={context.handleEmploymentStatusChange}
                  name="employmentStatus"
                >
                  <option value="" />
                  <option value="DEPEDAPDS">DepED - APDS</option>
                  <option value="DEPEDEHS">DepEd - FAS</option>
                  <option value="DEPEDNEWLYHIRED">
                    DepEd - Newly Hired (APDS)
                  </option>
                  <option value="DEPEDNEWLYHIREDFAS">
                    DepEd - Newly Hired (FAS)
                  </option>
                  <option value="EMPLOYED">Employer</option>
                  <option value="OTHERS">Unemployed - Others</option>
                  <option value="RETIRED">Retiree</option>
                  <option value="SELF-EMPLOYED">Self-employed</option>
                  <option value="STUDENT">Student</option>
                  <option value="UNPAID">Unpaid Family Worker</option>
                  <option value="WAGE.GOVT">
                    Wage & Salary Worker Government
                  </option>
                  <option value="WAGE.OCW">Wage & Salary Worker - OCW</option>
                  <option value="WAGE.PRIVATE">
                    Wage & Salary Worker - Private
                  </option>
                </MuiSelect>
                <FormHelperText
                  classes={{
                    root: classes.dropdownError,
                    error: classes.error
                  }}
                  component="span"
                >
                  {context.state.employmentStatusError}
                </FormHelperText>
              </FormControl>
              <TextField
                required
                type="text"
                autoComplete="family-name"
                color="secondary"
                id="employerName"
                name="employerName"
                label="Employer Name"
                className={classes.textField}
                value={context.state.employerName}
                onChange={context.change}
                error={context.state.employerNameError !== ""}
                helperText={context.state.employerNameError}
                margin="normal"
              />
              <FormControl
                className={classes.formControl}
                error={context.state.natureOfEmploymentError !== ""}
              >
                <InputLabel htmlFor="natureOfEmployment">
                  Nature Of Employment
                </InputLabel>
                <MuiSelect
                  native
                  value={context.state.natureOfEmployment}
                  onChange={context.handleNatureOfEmploymentChange}
                  name="natureOfEmployment"
                >
                  <option value="" />
                  <option value="10">Accommodation and Food Service</option>
                  <option value="20">Administrative/Support Service</option>
                  <option value="30">Agriculture/Forestry/Fishing</option>
                  <option value="40">Arts/Entertainment/Recreation</option>
                  <option value="60">Construction</option>
                  <option value="70">Education</option>
                  <option value="80">
                    Electricity/Gas/Steam/Air Conditioning Supply
                  </option>
                  <option value="90">
                    Extra-Territorial Organization/Bodies
                  </option>
                  <option value="100">Financial and Insurance</option>
                  <option value="110">Human Health/Social Work</option>
                  <option value="120">Information and Communication</option>
                  <option value="130">Manufacturing</option>
                  <option value="140">Mining/Quarrying</option>
                  <option value="150">Other Service Activities</option>
                  <option value="160">Private Household</option>
                  <option value="170">
                    Professional/Scientific/Technical Services
                  </option>
                  <option value="180">
                    Public Administrative and Defense/Compulsory Social Security
                  </option>
                  <option value="190">Real Estate</option>
                  <option value="220">Transportation and Storage</option>
                  <option value="230">
                    Water/Sewerage/Waste Management/Remediation
                  </option>
                  <option value="240">
                    Wholesale and Retail Trade/Repair of Motor Vehicles
                  </option>
                </MuiSelect>
                <FormHelperText
                  classes={{
                    root: classes.dropdownError,
                    error: classes.error
                  }}
                  component="span"
                >
                  {context.state.natureOfEmploymentError}
                </FormHelperText>
              </FormControl>
            </MuiThemeProvider>
          </form>
        )}
      </FormContext.Consumer>
    );
  }
}

const PersonalInformation1 = withStyles(styles, { withTheme: true })(
  PersonalInformation
);

class ContactInformation extends Component {
  render() {
    const { classes } = this.props;

    return (
      <FormContext.Consumer>
        {context => (
          <React.Fragment>
            <form>
              <MuiThemeProvider theme={theme}>
                <FormControl
                  className={classes.formControl}
                  error={context.state.landlineError !== ""}
                >
                  <InputLabel htmlFor="formatted-text-mask-input">
                    Landline
                  </InputLabel>
                  <Input
                    value={context.state.landline}
                    onChange={context.handleNumberChange("landline")}
                    id="formatted-text-mask-input"
                    inputComponent={HomeTelCustom}
                    helperText={context.state.mobileError}
                  />
                  <FormHelperText
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error
                    }}
                    component="span"
                  >
                    {context.state.landlineError}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  className={classes.formControl}
                  error={context.state.mobileError !== ""}
                >
                  <InputLabel htmlFor="formatted-text-mask-input">
                    Mobile
                  </InputLabel>
                  <Input
                    value={context.state.mobile}
                    onChange={context.handleNumberChange("mobile")}
                    id="formatted-text-mask-input"
                    inputComponent={MobileCustom}
                  />
                  <FormHelperText
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error
                    }}
                    component="span"
                  >
                    {context.state.mobileError}
                  </FormHelperText>
                </FormControl>
                <br />
                <br />
                <Typography variant="body1">Present Address</Typography>
                <TextField
                  type="text"
                  autoComplete="current-address"
                  color="primary"
                  id="currentAddress"
                  name="currentAddress"
                  label="House/building Address"
                  className={classes.textField}
                  value={context.state.currentAddress}
                  onChange={context.change}
                  error={context.state.currentAddressError !== ""}
                  helperText={context.state.currentAddressError}
                  margin="normal"
                />
                <FormControl
                  className={classes.formControl}
                  error={context.state.currentCountryError !== ""}
                >
                  <NoSsr>
                    <Select
                      styles={{ border: "1px solid black" }}
                      className={
                        context.state.currentCountryError !== ""
                          ? classes.autoCompleteStyle
                          : ""
                      }
                      classes={classes}
                      options={countrySuggestions}
                      components={components}
                      value={context.state.currentCountry}
                      onChange={context.handleCountryChange("currentCountry")}
                      placeholder={
                        context.state.currentCountryError !== "" ? (
                          <span style={{ color: "#f44336" }}>
                            Select Country Of Residence
                          </span>
                        ) : (
                          "Select Country Of Residence"
                        )
                      }
                    />
                  </NoSsr>
                  <FormHelperText
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error
                    }}
                    component="span"
                  >
                    {context.state.currentCountryError}
                  </FormHelperText>
                </FormControl>
                <TextField
                  type="text"
                  autoComplete="current-province"
                  color="primary"
                  id="currentProvince"
                  name="currentProvince"
                  label="Province"
                  className={classes.textField}
                  value={context.state.currentProvince}
                  onChange={context.change}
                  error={context.state.currentProvinceError !== ""}
                  helperText={context.state.currentProvinceError}
                  margin="normal"
                />

                <TextField
                  required
                  type="number"
                  autoComplete="current-zip-code"
                  color="primary"
                  id="currentZipCode"
                  name="currentZipCode"
                  label="Zip Code"
                  className={classes.textField}
                  value={context.state.currentZipCode}
                  onChange={context.change}
                  error={context.state.currentZipCodeError !== ""}
                  helperText={context.state.currentZipCodeError}
                  margin="normal"
                />
                <br />
                <br />
                <FormControl
                  component="fieldset"
                  error={context.state.sameAddressError !== ""}
                  className={classes.groupControl}
                >
                  <div style={{ display: "inline-flex" }}>
                    <FormLabel component="legend">
                      Same as Present Address
                    </FormLabel>
                  </div>
                  <RadioGroup
                    aria-label="address"
                    name="address"
                    className={classes.group}
                    value={context.state.sameAddress}
                    onChange={context.handleSameAddress}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio color="primary" />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio color="primary" />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>

                {context.state.sameAddress == "no" ? (
                  <Fragment>
                    <br />
                    <Typography variant="body1">Permanent Address</Typography>
                    <FormHelperText
                      style={{ color: "#f44336" }}
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error
                      }}
                      component="span"
                    >
                      {context.state.sameAddressError}
                    </FormHelperText>
                    <TextField
                      type="text"
                      autoComplete="permanent-address"
                      color="primary"
                      id="permanentAddress"
                      name="permanentAddress"
                      label="House/building Address"
                      className={classes.textField}
                      value={context.state.permanentAddress}
                      onChange={context.change}
                      error={context.state.permanentAddressError !== ""}
                      helperText={context.state.permanentAddressError}
                      margin="normal"
                    />
                    <FormControl
                      className={classes.formControl}
                      error={context.state.permanentCountryError !== ""}
                    >
                      <NoSsr>
                        <Select
                          styles={{ border: "1px solid black" }}
                          className={
                            context.state.permanentCountryError !== ""
                              ? classes.autoCompleteStyle
                              : ""
                          }
                          classes={classes}
                          options={countrySuggestions}
                          components={components}
                          value={context.state.permanentCountry}
                          onChange={context.handleCountryChange(
                            "permanentCountry"
                          )}
                          placeholder={
                            context.state.permanentCountryError !== "" ? (
                              <span style={{ color: "#f44336" }}>
                                Select Country Of Residence
                              </span>
                            ) : (
                              "Select Country Of Residence"
                            )
                          }
                        />
                      </NoSsr>
                      <FormHelperText
                        classes={{
                          root: classes.dropdownError,
                          error: classes.error
                        }}
                        component="span"
                      >
                        {context.state.permanentCountryError}
                      </FormHelperText>
                    </FormControl>
                    <TextField
                      type="text"
                      autoComplete="permanent-province"
                      color="primary"
                      id="permanentProvince"
                      name="permanentProvince"
                      label="Province"
                      className={classes.textField}
                      value={context.state.permanentProvince}
                      onChange={context.change}
                      error={context.state.permanentProvinceError !== ""}
                      helperText={context.state.permanentProvinceError}
                      margin="normal"
                    />
                    <TextField
                      required
                      type="number"
                      autoComplete="permanent-zip-code"
                      color="primary"
                      id="permanentZipCode"
                      name="permanentZipCode"
                      label="Zip Code"
                      className={classes.textField}
                      value={context.state.permanentZipCode}
                      onChange={context.change}
                      error={context.state.permanentZipCodeError !== ""}
                      helperText={context.state.permanentZipCodeError}
                      margin="normal"
                    />
                  </Fragment>
                ) : (
                  ""
                )}
              </MuiThemeProvider>
            </form>
          </React.Fragment>
        )}
      </FormContext.Consumer>
    );
  }
}

const ContactInformation1 = withStyles(styles, { withTheme: true })(
  ContactInformation
);

class ReviewApplication extends Component {
  render() {
    function dateOfBirthFormat(years) {
      return new Date(years).toLocaleDateString("en-US");
    }

    const { classes } = this.props;
    return (
      <FormContext.Consumer>
        {context => (
          <form>
            <Typography
              className={classes.headline}
              variant="body1"
              gutterBottom
            >
              Make sure that your email address and information are correct
              before submitting your online application.
            </Typography>

            <Table className={classes.table}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      EMAIL ADDRESS
                      <Button onClick={context.handleEdit("3")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.email}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      DATE OF BIRTH
                      <Button onClick={context.handleEdit("3")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {dateOfBirthFormat(context.state.dateOfBirth)}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      PREFERRED STORE
                      <Button onClick={context.handleEdit("3")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.branchAddr}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      FIRST NAME
                      <Button onClick={context.handleEdit("2")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.firstName}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      MIDDLE NAME
                      <Button onClick={context.handleEdit("2")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.middleName}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      LAST NAME
                      <Button onClick={context.handleEdit("2")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.lastName}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      COUNTRY OF BIRTH
                      <Button onClick={context.handleEdit("2")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.countryBirthCountry}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      PLACE OF BIRTH
                      <Button onClick={context.handleEdit("2")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.placeOfBirth}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      GENDER
                      <Button onClick={context.handleEdit("2")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.gender}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      NATIONALITY
                      <Button onClick={context.handleEdit("2")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.countryNationality}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      CIVIL STATUS
                      <Button onClick={context.handleEdit("2")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.civilStatus}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      TIN
                      <Button onClick={context.handleEdit("2")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.tin}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      EMPLOYMENT STATUS
                      <Button onClick={context.handleEdit("2")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.displayEmploymentStatus}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      EMPLOYER NAME
                      <Button onClick={context.handleEdit("2")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.employerName}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      NATURE OF EMPLOYMENT
                      <Button onClick={context.handleEdit("2")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.displayNatureOfEmployment}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      LANDLINE
                      <Button onClick={context.handleEdit("1")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.landline}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      MOBILE
                      <Button onClick={context.handleEdit("1")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.mobile}
                    </Typography>
                  </TableCell>
                </TableRow>
                <Typography variant="body2">PRESENT ADDRESS</Typography>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      HOUSE/BUILDING ADDRESS
                      <Button onClick={context.handleEdit("1")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.currentAddress}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      COUNTRY
                      <Button onClick={context.handleEdit("1")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.countryCurrentCountry}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      PROVINCE
                      <Button onClick={context.handleEdit("1")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.currentProvince}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      ZIP CODE
                      <Button onClick={context.handleEdit("1")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.currentZipCode}
                    </Typography>
                  </TableCell>
                </TableRow>
                <Typography variant="body2">PERMANENT ADDRESS</Typography>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      HOUSE/BUILDING ADDRESS
                      <Button onClick={context.handleEdit("1")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.permanentAddress}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      COUNTRY
                      <Button onClick={context.handleEdit("1")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.countryCurrentCountry}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      PROVINCE
                      <Button onClick={context.handleEdit("1")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.permanentProvince}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      ZIP CODE
                      <Button onClick={context.handleEdit("1")}>
                        <Edit className={classes.rightIcon} />
                      </Button>
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {context.state.permanentZipCode}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <FormControl
              className={classes.formControl}
              error={context.state.checkedError !== ""}
            >
              <div style={{ flexDirection: "row", display: "flex" }}>
                <FormControlLabel
                  style={{ marginRight: "1px", marginBottom: "0" }}
                  control={
                    <Checkbox
                      checked={context.state.checked}
                      onChange={context.handleCheckBox("checked")}
                      value="checked"
                      color="primary"
                    />
                  }
                />
                <div style={{ display: "flex" }}>
                  <Typography style={{ alignSelf: "center" }} variant="body1">
                    I agree to the &nbsp;
                    <u>
                      <ModalButtons
                        header="Privacy Policy"
                        dialogBody={<PrivacyStatementText />}
                        buttonTitle="Privacy Statement"
                      />
                    </u>
                    &nbsp; and &nbsp;
                    <u>
                      <ModalButtons
                        header=" Terms of Use "
                        dialogBody={<TermsOfUseText />}
                        buttonTitle="Terms of Use"
                      />
                    </u>
                  </Typography>
                </div>
              </div>
              <FormHelperText
                classes={{
                  root: classes.dropdownError,
                  error: classes.error
                }}
                component="p"
              >
                {context.state.checkedError}
              </FormHelperText>
            </FormControl>
            <Dialog
              open={context.state.thankYouAlert}
              onClose={context.handleThankYouClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Thank you"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your details were sent successfully!
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={context.handleThankYouClose} color="secondary">
                  OK
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={context.state.errorAlert}
              onClose={context.handleErrorClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Error"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  An error was encountered while trying to save your data.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={context.handleErrorClose} color="secondary">
                  OK
                </Button>
              </DialogActions>
            </Dialog>
          </form>
        )}
      </FormContext.Consumer>
    );
  }
}

const ReviewApplication1 = withStyles(styles, { withTheme: true })(
  ReviewApplication
);

function getSteps(applicationType) {
  return [
    "Get Started",
    "Personal Information",
    "Contact Information",
    "Review Application"
  ];
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return <ContactInformation1 />;
    case 1:
      return <PersonalInformation1 />;
    case 2:
      return <ContactInformation1 />;
    case 3:
      return <ReviewApplication1 />;
    default:
      return "Unknown step";
  }
}

class TDApplicationForm extends Component {
  state = {
    finalLifestage: "",
    finalInvestment: 0,
    finalInvestmentTime: "30",
    preferredStore: "",
    preferredStoreError: false,
    title: "",
    lastName: "",
    lastNameError: "",
    firstName: "",
    firstNameError: "",
    middleName: "",
    middleNameError: "",
    suffix: "",
    mobile: "",
    mobileError: "",
    landline: "",
    landlineError: "",
    email: "",
    emailError: "",
    dateOfBirth: "",
    dateOfBirthError: "",
    gender: "",
    genderError: "",
    civilStatus: "",
    civilStatusError: "",
    nationality: null,
    nationalityError: "",
    countryCode: null,
    countryBirthCountry: null,
    countryNationality: null,
    countryCurrentCountry: null,
    countryPermanentCountry: null,
    birthCountry: null,
    birthCountryError: "",
    placeOfBirth: "",
    placeOfBirthError: "",
    currentHouseNumber: "",
    currentAddress: "",
    currentAddressError: "",
    currentProvince: "",
    currentProvinceError: "",
    currentCountry: null,
    currentCountryError: "",
    currentZipCode: "",
    currentZipCodeError: "",
    sameAddress: "no",
    sameAddressError: "",
    permanentHouseNumber: "",
    permanentAddress: "",
    permanentAddressError: "",
    permanentProvince: "",
    permanentProvinceError: "",
    permanentCountry: null,
    permanentCountryError: "",
    permanentZipCode: "",
    permanentZipCodeError: "",
    employmentStatus: "",
    displayEmploymentStatus: "",
    employmentStatusError: "",
    natureOfEmployment: "",
    displayNatureOfEmployment: "",
    natureOfEmploymentError: "",
    employerName: "",
    employerNameError: "",
    tin: "",
    tinError: "",
    checked: false,
    checkedError: "",
    open: false,
    saveButton: false,
    thankYouAlert: false,
    errorAlert: false,
    activeStep: 0,
    referenceid: null,
    openBday: false,
    verifyBdayValue: "",
    verifyBdayError: false,
    branchCode: "",
    branchTempCode: "",
    redirect: false,
    savereferenceid: "",
    btnDisabled: false
  };


  componentDidMount() {
    //check if referenceid was set
    if (this.props.match != undefined) {
      this.setState({
        referenceid: this.props.match.params.referenceid
      });
      // your code here
    }
    if (this.state.referenceid) {
      this.setState({
        openBday: true
      });
    }
    this.loadData();
  }

  validate = () => {
    function reactMaskCleaner(value) {
      return value.replace(/[\s\x+/_()-]/g, "");
    }

    let isError = "";

    const errors = {
      emailError: "",
      preferredStoreError: "",
      firstNameError: "",
      middleNameError: "",
      lastNameError: "",
      dateOfBirthError: "",
      selectedDateError: "",
      placeOfBirthError: "",
      genderError: "",
      nationalityError: "",
      civilStatusError: "",
      birthCountryError: "",
      mobileError: "",
      landlineError: "",
      currentAddressError: "",
      currentCountryError: "",
      currentProvinceError: "",
      currentZipCodeError: "",
      sameAddressError: "",
      permanentAddressError: "",
      permanentCountryError: "",
      permanentProvinceError: "",
      permanentZipCodeError: "",
      tinError: "",
      employmentStatusError: "",
      natureOfEmploymentError: "",
      employerNameError: "",
      checkedError: "",
      reg: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@+(?:[A-Z]{2})|(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[A-Z]{2}|com|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum)\b/
    };
    switch (this.state.activeStep) {
      case 0:
        if (
          errors.reg.test(this.state.email) == "" ||
          this.state.email.length > 35
        ) {
          isError = true;
          errors.emailError = "Email is invalid";
        }
        if (this.state.dateOfBirth === "") {
          isError = true;
          errors.dateOfBirthError = "Please select a birth date";
        }
        if (this.state.branchCode === null) {
          isError = true;
          errors.preferredStoreError = "Please select Preferred Store.";
        }
        if (isError) {
          this.setState(errors);
        }
        return isError;
      case 1:
        const cleanTin = reactMaskCleaner(this.state.tin);
        if (
          this.state.firstName.length < 2 ||
          this.state.firstName.length > 35
        ) {
          isError = true;
          errors.firstNameError =
            "First name should be between 2 to 35 characters long";
        }
        if (
          this.state.middleName.length < 2 ||
          this.state.middleName.length > 35
        ) {
          isError = true;
          errors.middleNameError =
            "Middle name should be between 2 to 35 characters long";
        }
        if (this.state.lastName.length < 2 || this.state.lastName.length > 35) {
          isError = true;
          errors.lastNameError =
            "Last name should be between 2 to 35 characters long";
        }

        if (this.state.birthCountry === null) {
          isError = true;
          errors.birthCountryError = "Please select country of birth.";
        }
        if (this.state.placeOfBirth < 3) {
          isError = true;
          errors.placeOfBirthError = "Please Input a valid place of birth";
        }
        if (this.state.gender === "") {
          isError = true;
          errors.genderError = "Please select gender";
        }
        if (this.state.nationality === null) {
          isError = true;
          errors.nationalityError = "Please select nationality.";
        }
        if (this.state.civilStatus === "") {
          isError = true;
          errors.civilStatusError = "Please select civil status";
        }
        if (cleanTin.length < 9 || cleanTin.length > 35) {
          isError = true;
          errors.tinError = "Tin number is invalid";
        }
        if (this.state.employmentStatus === "") {
          isError = true;
          errors.employmentStatusError = "Please select an employment status";
        }
        if (
          this.state.employerName.length < 1 ||
          this.state.employerName.length > 35
        ) {
          isError = true;
          errors.employerNameError = "Employer Name is invalid";
        }
        if (this.state.natureOfEmployment === "") {
          isError = true;
          errors.natureOfEmploymentError = "Please select nature of employment";
        }

        if (isError) {
          this.setState(errors);
        }
        return isError;

      case 2:
        const cleanMobile = reactMaskCleaner(this.state.mobile);
        const cleanLandline = reactMaskCleaner(this.state.landline);

        if (cleanLandline.length < 9 || cleanLandline.length > 17) {
          isError = true;
          errors.landlineError = "Landline is invalid";
        }
        if (cleanMobile.length < 12 || cleanMobile.length > 17) {
          isError = true;
          errors.mobileError = "Mobile is invalid";
        }

        if (this.state.currentCountry === null) {
          isError = true;
          errors.currentCountryError = "Please select country.";
        } else if (this.state.currentCountry.length < 1) {
          isError = true;
          errors.currentCountryError = "Please select country.";
        }

        if (this.state.currentZipCode.length !== 4) {
          isError = true;
          errors.currentZipCodeError = "Please input the correct zip code";
        }
        if (this.state.sameAddress === "no") {
          errors.sameAddressError = "Please input your permanent address";

          if (this.state.permanentCountry === null) {
            isError = true;
            errors.permanentCountryError = "Please select country.";
          } else if (this.state.permanentCountry.length < 1) {
            isError = true;
            errors.permanentCountryError = "Please select country.";
          }

          if (this.state.permanentZipCode.length !== 4) {
            isError = true;
            errors.permanentZipCodeError = "Please input the correct zip code";
          }
        } else {
          const permanentAddress = {
            permanentAddress: this.state.currentAddress,
            permanentProvince: this.state.currentProvince,
            permanentCountry: this.state.countryCurrentCountry,
            permanentZipCode: this.state.currentZipCode
          };
          this.setState(permanentAddress);
        }

        if (isError) {
          this.setState(errors);
        }
        return isError;
      case 3:
        if (this.state.checked === false) {
          isError = true;
          errors.checkedError =
            "You can only submit this form if you agree to our privacy statement and terms of use";
        }
        if (isError) {
          this.setState(errors);
        }
        return isError;
      default:
        return isError;
    }
  };

  handleNext = e => {
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      this.setState({
        emailError: "",
        preferredStoreError: "",
        firstNameError: "",
        middleNameError: "",
        lastNameError: "",
        dateOfBirthError: "",
        selectedDateError: "",
        placeOfBirthError: "",
        genderError: "",
        nationalityError: "",
        civilStatusError: "",
        birthCountryError: "",
        mobileError: "",
        landlineError: "",
        currentAddressError: "",
        currentCountryError: "",
        currentProvinceError: "",
        currentZipCodeError: "",
        sameAddressError: "",
        permanentAddressError: "",
        permanentCountryError: "",
        permanentProvinceError: "",
        permanentZipCodeError: "",
        tinError: "",
        employmentStatusError: "",
        natureOfEmploymentError: "",
        employerNameError: "",
        checkedError: ""
      });
      this.setState(prevState => ({
        activeStep: prevState.activeStep + 1
      }));
    }
  };

  submitForm = () => {
    const err = this.validate();

    if (!err) {
      //save data
      this.setState({ btnDisabled: true });

      var ewAppFormData = new FormData();
      ewAppFormData.append("customeremail", this.state.email);
      ewAppFormData.append("DateOfBirth", setDateBackEnd(this.state.dateOfBirth));
      ewAppFormData.append("StageInLife", this.state.finalLifestage);
      ewAppFormData.append(
        "AmountToInvest",
        this.state.finalInvestment.toLocaleString("en")
      );
      ewAppFormData.append(
        "Tenor",
        this.formatYear(this.state.finalInvestmentTime)
      );
      ewAppFormData.append("FirstName", this.state.firstName);
      ewAppFormData.append("MiddleName", this.state.middleName);
      ewAppFormData.append("LastName", this.state.lastName);
      ewAppFormData.append("CountryOfBirth", this.state.countryBirthCountry);
      ewAppFormData.append("PlaceOfBirth", this.state.placeOfBirth);
      ewAppFormData.append("Gender", this.state.gender);
      ewAppFormData.append("PhoneNo", this.state.landline);
      ewAppFormData.append("MobileNo", this.state.mobile);
      ewAppFormData.append("CurrentAddress", this.state.currentAddress);
      ewAppFormData.append("CurrentProvince", this.state.currentProvince);
      ewAppFormData.append("CurrentZipCode", this.state.currentZipCode);
      ewAppFormData.append("CurrentCountry", this.state.countryCurrentCountry);
      ewAppFormData.append("PermanentAddress", this.state.permanentAddress);
      ewAppFormData.append("PermanentProvince", this.state.permanentProvince);
      ewAppFormData.append("PermanentZipCode", this.state.permanentZipCode);
      ewAppFormData.append(
        "PermanentCountry",
        this.state.countryPermanentCountry
      );
      ewAppFormData.append("preferedstore", this.state.branchTempCode);
      ewAppFormData.append("nationality", this.state.countryNationality);
      ewAppFormData.append("maritalstatus", this.state.civilStatus);
      ewAppFormData.append("tin", this.state.tin);
      ewAppFormData.append("employmentstatus", this.state.employmentStatus);
      ewAppFormData.append("employername", this.state.employerName);
      ewAppFormData.append("SameAddress", this.state.sameAddress);
      ewAppFormData.append("ReferenceId", this.state.savereferenceid);

      // TDSubmitForm

      const fetchURL = "/data/apiconfig.json";
      fetch(fetchURL)
        .then(response => response.json())
        .then(response => {
          fetch(
            response.timedepositeapi,
            {
              method: "POST",
              body: ewAppFormData
            }
          )
          .then(apiresponse => {
            if (apiresponse.ok) {
              //reset form
              this.setState({
                finalLifestage: "",
                finalInvestment: "0",
                finalInvestmentTime: "30",
                startInvestment: 0,
                preferredStore: "",
                preferredStoreError: false,
                title: "",
                lastName: "",
                lastNameError: "",
                firstName: "",
                firstNameError: "",
                middleName: "",
                middleNameError: "",
                suffix: "",
                mobile: "",
                mobileError: "",
                landline: "",
                landlineError: "",
                email: "",
                emailError: "",
                dateOfBirth: "",
                dateOfBirthError: "",
                gender: "",
                genderError: "",
                civilStatus: "",
                civilStatusError: "",
                nationality: null,
                nationalityError: "",
                countryCode: null,
                countryBirthCountry: null,
                countryNationality: null,
                countryCurrentCountry: null,
                countryPermanentCountry: null,
                birthCountry: null,
                birthCountryError: "",
                placeOfBirth: "",
                placeOfBirthError: "",
                currentHouseNumber: "",
                currentAddress: "",
                currentAddressError: "",
                currentProvince: "",
                currentProvinceError: "",
                currentCountry: null,
                currentCountryError: "",
                currentZipCode: "",
                currentZipCodeError: "",
                sameAddress: "no",
                sameAddressError: "",
                permanentHouseNumber: "",
                permanentAddress: "",
                permanentAddressError: "",
                permanentProvince: "",
                permanentProvinceError: "",
                permanentCountry: null,
                permanentCountryError: "",
                permanentZipCode: "",
                permanentZipCodeError: "",
                employmentStatus: "",
                employmentStatusError: "",
                natureOfEmployment: "",
                natureOfEmploymentError: "",
                employerName: "",
                employerNameError: "",
                tin: "",
                tinError: "",
                checked: false,
                checkedError: "",
                open: false,
                saveButton: false,
                activeStep: 0,
                thankYouAlert: true,
                redirect: true
              });

              this.props.handleClose();
            } else {
              this.setState({
                errorAlert: true,
                btnDisabled: false
              });
            }
          })
          .catch(err => {
            console.log(err);
            this.setState({
              errorAlert: true,
              btnDisabled: false
            });
          });
      })
    }
  };

  findAddress(inval) {
    if (inval === null) {
      return null;
    }

    var branddata = rawsuggestions.find(function(suggestion) {
      return suggestion.branchcode === inval;
    });

    if (branddata !== undefined) {
      return branddata.address;
    } else {
      return null;
    }
  }

  formatYear(days) {
    if (days > 360) {
      return days / 360 + " years";
    } else {
      return days + " days";
    }
  }

  saveForm = () => {
    var ewAppFormData = new FormData();
    ewAppFormData.append("customeremail", this.state.email);
    ewAppFormData.append("DateOfBirth", setDateBackEnd(this.state.dateOfBirth));
    ewAppFormData.append("StageInLife", this.state.finalLifestage);
    ewAppFormData.append(
      "AmountToInvest",
      this.state.finalInvestment.toLocaleString("en")
    );
    ewAppFormData.append(
      "Tenor",
      this.formatYear(this.state.finalInvestmentTime)
    );
    ewAppFormData.append("FirstName", this.state.firstName);
    ewAppFormData.append("MiddleName", this.state.middleName);
    ewAppFormData.append("LastName", this.state.lastName);
    ewAppFormData.append("CountryOfBirth", this.state.countryBirthCountry);
    ewAppFormData.append("PlaceOfBirth", this.state.placeOfBirth);
    ewAppFormData.append("Gender", this.state.gender);
    ewAppFormData.append("PhoneNo", this.state.landline);
    ewAppFormData.append("MobileNo", this.state.mobile);
    ewAppFormData.append("CurrentAddress", this.state.currentAddress);
    ewAppFormData.append("CurrentProvince", this.state.currentProvince);
    ewAppFormData.append("CurrentZipCode", this.state.currentZipCode);
    ewAppFormData.append("CurrentCountry", this.state.countryCurrentCountry);
    ewAppFormData.append("PermanentAddress", this.state.permanentAddress);
    ewAppFormData.append("PermanentProvince", this.state.permanentProvince);
    ewAppFormData.append("PermanentZipCode", this.state.permanentZipCode);
    ewAppFormData.append(
      "PermanentCountry",
      this.state.countryPermanentCountry
    );
    ewAppFormData.append("preferedstore", this.state.branchTempCode);
    ewAppFormData.append("nationality", this.state.countryNationality);
    ewAppFormData.append("maritalstatus", this.state.civilStatus);
    ewAppFormData.append("tin", this.state.tin);
    ewAppFormData.append("employmentstatus", this.state.employmentStatus);
    ewAppFormData.append("employername", this.state.employerName);
    ewAppFormData.append("SameAddress", this.state.sameAddress);
    ewAppFormData.append("ReferenceId", this.state.savereferenceid);
    // ewFormData.append('',);

    // TDSaveForm
    /*
    Change fetch to proper URL
    */

    // fetch('https://www.eastwestbanker.com/OnlineNAC/Application/Add', {
    // fetch('https://172.28.11.74/onlinenac/application/add', {
    // fetch('http://localhost:8080/ewmock/save.php', {
    fetch(
      "https://corporate-website.azure-api.net/api/timedeposit/applicationsvc/submit",
      {
        method: "POST",
        body: ewAppFormData
      }
    )
      .then(response => {
        if (response.ok) {
          // window.dataLayer.push({
          //   ewformeventcat: "EW Family Ties Application Form Save",
          //   ewformeventaction: "Details successfully saved!",
          //   event: "ewformevent"
          // });

          // console.log('Save OK!');

          // saveStatus = true;
          return response.text();
        } else {
          // window.dataLayer.push({
          //   ewformeventcat: "EW Family Ties Application Form Save",
          //   ewformeventaction: "Save API Error!!!",
          //   event: "ewformevent"
          // });

          // saveStatus = false;
          return false;
        }
      })
      .then(text => {
        // console.log(text.trim());
        this.setState({
          savereferenceid: text.trim()
        });
      })
      .catch(err => {
        // window.dataLayer.push({
        //   ewformeventcat: "EW Family Ties Application Form Save",
        //   ewformeventaction: "Save API Error!!!",
        //   event: "ewformevent"
        // });

        // saveStatus = false;
        return false;
      });

    // return saveStatus;
  };

  //verify bday section

  loadData() {
    let tempdate = this.state.verifyBdayValue;
    var ewAppFormData = new FormData();
    ewAppFormData.append("referenceid", this.state.referenceid);
    ewAppFormData.append("DateOfBirth", tempdate);

    // TDRetrieveForm
    /*
    Change fetch to proper URL
    */

    fetch(
      "https://corporate-website.azure-api.net/api/timedeposit/applicationsvc/submit",
      {
        method: "POST",
        body: ewAppFormData
      }
    )
      .then(response => {
        // console.log(response);
        // console.log(response.ok);
        // console.log(response.status);
        if (response.ok) {
          // window.dataLayer.push({
          //   ewformeventcat: "EW Family Ties Application Form Save",
          //   ewformeventaction: "Details successfully saved!",
          //   event: "ewformevent"
          // });

          //set data
          // console.log(response);
          return response.json();
        } else {
          // window.dataLayer.push({
          //   ewformeventcat: "EW Family Ties Application Form Save",
          //   ewformeventaction: "Save API Error!!!",
          //   event: "ewformevent"
          // });

          //set bday error
          this.setState({
            verifyBdayError: "Wrong Birthday"
          });

          return false;
        }
      })
      .then(data => {
        // console.log(data);
        if (data) {
          this.setState({
            openBday: false,
            email: data.customeremail,
            dateOfBirth: data.DateOfBirth,
            firstName: data.FirstName,
            middleName: data.MiddleName,
            lastName: data.LastName,
            countryBirthCountry: data.CountryOfBirth,
            placeOfBirth: data.PlaceOfBirth,
            gender: data.Gender,
            landline: data.PhoneNo,
            mobile: data.MobileNo,
            permanentAddress: data.PermanentAddress,
            permanentProvince: data.PermanentProvince,
            permanentZipCode: data.PermanentZipCode,
            permanentCountry: data.PermanentCountry,
            civilStatus: data.maritalstatus,
            branchCode: data.preferedstore
          });
        }
      })
      .catch(err => {
        // window.dataLayer.push({
        //   ewformeventcat: "EW Family Ties Application Form Save",
        //   ewformeventaction: "Save API Error!!!",
        //   event: "ewformevent"
        // });

        //set bday error
        this.setState({
          verifyBdayError: "Connection Error!"
        });
      });
    // .then(response => response.json())
    // .then(response => {
    //   this.setState({
    //     activityData: response
    //   });
    // })
    // .catch((error) => {
    //   console.log(error);
    // });
  }

  handleBdayClose = () => {
    this.setState({
      openBday: false
    });
  };

  handleBdayChange = date => {
    this.setState({
      verifyBdayValue: date
    });
  };

  handleBdaySubmit = () => {
    this.loadData();
  };

  onSubmit = e => {
    e.preventDefault();
    this.submitForm();
  };

  onSave = () => {
    this.saveForm();
  };

  handleBack = () => {
    this.setState(prevState => ({
      activeStep: prevState.activeStep - 1
    }));
  };

  setValues(stage, principal, tenor) {
    this.setState({
      finalLifestage: stage,
      finalInvestment: principal,
      finalInvestmentTime: tenor
    });
  }

  render() {
    const { classes, theme } = this.props;
    const { activeStep, redirect, applicationType } = this.state;
    const steps = getSteps(applicationType);

    if (this.state.redirect) {
      return <Redirect to="/deposits/timedeposit/thankyou" />;
    }

    return (
      <CalculatorProvider>
        <FormContext.Provider
          value={{
            state: this.state,
            change: e => {
              this.setState({
                [e.target.name]: e.target.value
              });
            },
            handleNatureOfEmploymentChange: e => {
              this.setState({
                [e.target.name]: e.target.value,
                displayNatureOfEmployment:
                  e.target.options[e.target.selectedIndex].text
              });
            },
            handleEmploymentStatusChange: e => {
              this.setState({
                [e.target.name]: e.target.value,
                displayEmploymentStatus:
                  e.target.options[e.target.selectedIndex].text
              });
            },
            handleDateChange: date => {
              this.setState({ dateOfBirth: date });
            },
            handleSelectChange: name => value => {
              this.setState({
                [name]: value,
                branchTempCode: value.value,
                branchAddr: this.findAddress(value.value)
              });
            },
            handleNumberChange: name => event => {
              this.setState({
                [name]: event.target.value
              });
            },
            handleCountryChange: name => value => {
              if (name === "birthCountry") {
                this.setState({
                  [name]: value,
                  countryCode: value.value,
                  countryBirthCountry: value.label
                });
              }
              if (name === "nationality") {
                this.setState({
                  [name]: value,
                  countryCode: value.value,
                  countryNationality: value.label
                });
              }
              if (name === "currentCountry") {
                this.setState({
                  [name]: value,
                  countryCode: value.value,
                  countryCurrentCountry: value.label
                });
              }
              if (this.state.sameAddress === "no") {
                if (name === "permanentCountry") {
                  this.setState({
                    [name]: value,
                    countryCode: value.value,
                    countryPermanentCountry: value.label
                  });
                }
              }
            },
            handleEdit: step => () => {
              this.setState(prevState => ({
                activeStep: prevState.activeStep - step
              }));
              window.scrollTo(0, 0);
            },
            handleSameAddress: e => {
              this.setState({ sameAddress: e.target.value });
            },
            handleCheckBox: name => e => {
              this.setState({ [name]: e.target.checked });
            },
            handleThankYouClose: () => {
              this.setState({ thankYouAlert: false });
            },
            handleSaveButton: () => {
              this.setState({ saveButton: false });
            },
            handleErrorClose: () => {
              this.setState({ errorAlert: false });
            }
          }}
        >
          <div className="gridContainer">
            <Grid
              container
              className={classnames(classes.spacer, classes.paperPadding)}
            >
              <Stepper
                style={{ width: "100%" }}
                activeStep={activeStep}
                orientation="vertical"
              >
                {steps.map((label, index) => {
                  return (
                    <Step key={label}>
                      <StepLabel
                        classes={{
                          iconContainer: classes.iconContainer,
                          completed: classes.iconContainer
                        }}
                      >
                        {label}
                      </StepLabel>
                      <StepContent>
                        <div>{getStepContent(index, applicationType)}</div>
                        <div className={classes.actionsContainer}>
                          <div>
                            <Button
                              disabled={activeStep === 0}
                              onClick={this.handleBack}
                              className={classes.button}
                            >
                              Back
                            </Button>
                            &nbsp;&nbsp;
                            {activeStep < 1 ? (
                              ""
                            ) : (
                              <SaveButton
                                onClick={this.onSave}
                                header=" Save"
                                dialogBody="Your details were successfully saved! Please check your email to access this form again!"
                                buttonTitle="SAVE"
                              />
                            )}
                            &nbsp;&nbsp;
                            {activeStep === steps.length - 1 ? (
                              <Button
                                variant="contained"
                                color="secondary"
                                onClick={this.onSubmit}
                                className={classes.button}
                              >
                                Submit
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                color="secondary"
                                onClick={this.handleNext}
                                className={classes.button}
                              >
                                Next
                              </Button>
                            )}
                          </div>
                        </div>
                      </StepContent>
                    </Step>
                  );
                })}
              </Stepper>
            </Grid>
          </div>
        </FormContext.Provider>

        <Dialog
          open={this.state.openBday}
          onClose={this.handleBdayClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">User verification</DialogTitle>
          <DialogContent>
            <DialogContentText>
              To continue with your application, please enter your birthday.
            </DialogContentText>
            <br />

            <TextField
              id="date"
              label="Birthday"
              type="date"
              name="dateOfBirth"
              className={classes.textField}
              value={this.state.verifyBdayValue}
              onChange={this.change}
              inputProps={{
                min: "1910-07-31",
                max: maxDate18
              }}
              InputLabelProps={{
                shrink: true
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleBdayClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleBdaySubmit} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </CalculatorProvider>
    );
  }
}

export default withStyles(styles, { withTheme: true })(TDApplicationForm);
